export const applyRangeSelect = (
  clicked: Date,
  currentFrom: Date | null,
  currentTo: Date | null,
): { from: Date; to: Date | null } => {
  // Both set or no selection: start fresh
  if (!currentFrom || currentTo !== null) {
    return { from: clicked, to: null };
  }

  // Only from is set
  if (clicked > currentFrom) {
    return { from: currentFrom, to: clicked };
  }

  // Clicked on or before from: new from
  return { from: clicked, to: null };
};

/**
 * Activity-site range select: a single day is a complete search, so the first
 * click selects [day, day] and the search button lights up immediately. The
 * range can still be widened — clicking a later day extends `to`; clicking an
 * earlier day (or restarting after a widened range) begins a new single day.
 */
export const applyActivityRangeSelect = (
  clicked: Date,
  currentFrom: Date | null,
  currentTo: Date | null,
): { from: Date; to: Date } => {
  const isSingleDay =
    !!currentFrom && !!currentTo && currentFrom.getTime() === currentTo.getTime();

  // Extend the auto-selected single day into a range.
  if (isSingleDay && currentFrom && clicked > currentFrom) {
    return { from: currentFrom, to: clicked };
  }

  // Anything else — no selection, a completed range, an earlier day, or a
  // re-click on the selected day — starts a new single-day selection.
  return { from: clicked, to: clicked };
};
